export default __webpack_public_path__ + "static/media/atg_bg.36e69668.webp";